import { render, staticRenderFns } from "./game-list.vue?vue&type=template&id=d94976fc&scoped=true&"
import script from "./game-list.vue?vue&type=script&lang=js&"
export * from "./game-list.vue?vue&type=script&lang=js&"
import style0 from "./game-list.vue?vue&type=style&index=0&id=d94976fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94976fc",
  null
  
)

export default component.exports